import { ComboBoxOption } from '@slal/ui/forms';

export const titles = ['Mr', 'Mrs', 'Miss', 'Ms', 'Dr', 'Professor', 'Reverend', 'Sir', 'Lady', 'Captain'];

export const titleSelectOptions: ComboBoxOption[] = titles.map(value => ({
    label: value,
    value,
}));
